import React, { useState } from 'react';
import { X } from 'lucide-react';
import './CustomDialog.css';

// Alert Dialog
export function AlertDialog({ title, message, onClose, type = 'info' }) {
  return (
    <div className="custom-dialog-overlay" data-testid="alert-dialog-overlay">
      <div className={`custom-dialog ${type}`} data-testid="alert-dialog">
        <button 
          className="dialog-close" 
          onClick={onClose}
          data-testid="alert-close-button"
        >
          <X size={20} />
        </button>
        
        <div className="dialog-icon">
          {type === 'success' && '✅'}
          {type === 'error' && '❌'}
          {type === 'warning' && '⚠️'}
          {type === 'info' && 'ℹ️'}
        </div>
        
        {title && <h3 className="dialog-title">{title}</h3>}
        <p className="dialog-message">{message}</p>
        
        <button 
          onClick={onClose} 
          className="btn-dialog-ok"
          data-testid="alert-ok-button"
        >
          OK
        </button>
      </div>
    </div>
  );
}

// Prompt Dialog
export function PromptDialog({ title, message, placeholder, onConfirm, onCancel, maxLength = 100 }) {
  const [value, setValue] = useState('');

  const handleConfirm = () => {
    onConfirm(value);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && value.trim()) {
      handleConfirm();
    }
  };

  return (
    <div className="custom-dialog-overlay" data-testid="prompt-dialog-overlay">
      <div className="custom-dialog" data-testid="prompt-dialog">
        <button 
          className="dialog-close" 
          onClick={onCancel}
          data-testid="prompt-close-button"
        >
          <X size={20} />
        </button>
        
        <div className="dialog-icon">📝</div>
        
        {title && <h3 className="dialog-title">{title}</h3>}
        {message && <p className="dialog-message">{message}</p>}
        
        <input
          type="text"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onKeyPress={handleKeyPress}
          placeholder={placeholder}
          maxLength={maxLength}
          className="dialog-input"
          autoFocus
          data-testid="prompt-input"
        />
        
        <div className="dialog-actions">
          <button 
            onClick={onCancel} 
            className="btn-dialog-cancel"
            data-testid="prompt-cancel-button"
          >
            Abbrechen
          </button>
          <button 
            onClick={handleConfirm} 
            className="btn-dialog-confirm"
            disabled={!value.trim()}
            data-testid="prompt-confirm-button"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
}

// Confirm Dialog
export function ConfirmDialog({ title, message, onConfirm, onCancel, confirmText = 'Bestätigen', cancelText = 'Abbrechen' }) {
  return (
    <div className="custom-dialog-overlay" data-testid="confirm-dialog-overlay">
      <div className="custom-dialog warning" data-testid="confirm-dialog">
        <div className="dialog-icon">❓</div>
        
        {title && <h3 className="dialog-title">{title}</h3>}
        <p className="dialog-message">{message}</p>
        
        <div className="dialog-actions">
          <button 
            onClick={onCancel} 
            className="btn-dialog-cancel"
            data-testid="confirm-cancel-button"
          >
            {cancelText}
          </button>
          <button 
            onClick={onConfirm} 
            className="btn-dialog-confirm danger"
            data-testid="confirm-ok-button"
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}
